import { fallback } from "@tanstack/zod-adapter";
import { z } from "zod";

/**
 * Typed router id for the MCP gateways list route. Centralized so the
 * various sheets, drawers, and effects that bind to this route's search
 * params agree on one string and can't silently drift.
 */
export const MCP_GATEWAYS_ROUTE_ID =
  "/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways" as const;

export const mcpGatewaysSearchSchema = z.object({
  create: fallback(z.boolean(), false).default(false),
  tools: fallback(z.array(z.string()), []).default([]),
  /**
   * When set to a gateway id, the connect sheet auto-opens for the matching
   * row on the list page. Used by the gateway create dialog to deep-link the
   * user straight into the connect flow after creating a gateway.
   */
  connect: fallback(z.string(), "").default(""),
});

export type McpGatewaysSearch = z.infer<typeof mcpGatewaysSearchSchema>;

export const mcpGatewaysSearchDefaults: McpGatewaysSearch = {
  create: false,
  tools: [],
  connect: "",
};
